import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//
import Grid from "@mui/material/Grid";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
//
import CustomTabs from "./left/CustomTabs";
import ImportTool from "./right/importTool/ImportTool";
import ExportTool from "./right/exportTool/ExportTool";
import DatasetTool from "./right/datasetTool/DatasetTool";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const TopPanel = () => {
  const [value, setValue] = React.useState(0);

  return (
    <Grid container justifyContent="space-between">
      <Grid item xs={12} sm={12} md={4}>
        <CustomTabs />
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={8}
        container
        justifyContent="flex-end"
        spacing={1}
      >
        <Grid item>
          <ImportTool />
        </Grid>
        <Grid item>
          <ExportTool />
        </Grid>
        {/* <Grid item>
          <DatasetTool />
        </Grid> */}
      </Grid>
    </Grid>
  );
};

export default TopPanel;
